import { useRef } from "react";
import { Link, useParams } from "react-router";

import { useGetProfile, useGetProfileSuspense } from "@/api/bale";
import { ContentFull, ContentLayout } from "@/components/ContentLayout";
import { FullScreenLayout } from "@/components/FullScreenLayout";
import { IconButton } from "@/components/IconButton";
import { Subtitle } from "@/components/Subtitle";
import { TextLoading } from "@/components/TextLoading";
import { profileDisplayName, profileHasDisplayName } from "@/model/profile";

import { FriendsCard } from "./components/FriendsCard";
import { HostedEventsCard } from "./components/HostedEventsCard";
import { ProfileCard } from "./components/ProfileCard/ProfileCard";
import { ReportAccountModal } from "./components/ReportAccountModal";

export function ProfilePage() {
  const params = useParams();
  const accountId = params.accountId!;
  const profile = useGetProfile(accountId, { query: { select: (data) => data.data.profile } });
  const me = useGetProfileSuspense("@me", { query: { select: (data) => data.data.profile } });

  const reportModal = useRef<HTMLDialogElement>(null);

  return (
    <FullScreenLayout>
      {profile.data && <meta property="og:title" content={profileDisplayName(profile.data)} />}
      {!!profile.data?.biography && <meta property="og:description" content={profile.data?.biography.raw} />}
      <meta property="og:url" content={window.location.href} />
      <ContentLayout
        title={
          <Link to={`/profile/${accountId}`}>{profile.data ? profileDisplayName(profile.data) : <TextLoading />}</Link>
        }
        subtitle={!!profile.data && profileHasDisplayName(profile.data) && <Subtitle>{profile.data.id}</Subtitle>}
        wet
      >
        <ContentFull>
          <div className="flex h-26 flex-row items-start justify-end p-2">
            {profile.data && me.data.id !== profile.data.id && (
              <IconButton type="button" onClick={() => reportModal.current?.showModal()} name="alert-triangle" />
            )}
          </div>
          <div className="grid grid-cols-1 content-start gap-4 xs:grid-cols-2 sm:grid-cols-3">
            <ProfileCard className="xs:col-span-2" accountId={accountId} />
            <HostedEventsCard accountId={accountId} />
            <FriendsCard accountId={accountId} />
          </div>
        </ContentFull>
      </ContentLayout>
      <ReportAccountModal ref={reportModal} accountId={accountId} onClose={() => reportModal.current?.close()} />
    </FullScreenLayout>
  );
}
